<template>
<div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
        <el-form :inline="true" size="small">
            <!-- <el-form-item>
          <el-input v-model="schoolName" placeholder="学校名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getPilotList()">搜索</el-button>
        </el-form-item>-->
        </el-form>
    </header>

    <el-table :data="siteList" @selection-change="handleSelectionChange" style="width: 100%" :row-key="getKeys">
        <el-table-column prop="Id" type="selection" :reserve-selection="true" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="schoolName" label="学校名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dateCreated" label="创建时间" show-overflow-tooltip></el-table-column>
        <el-table-column prop="schoolLevel" label="学校类型" show-overflow-tooltip>
            <template slot-scope="scope">
                <span v-if="scope.row.schoolLevel == 1">中职</span>
                <span v-if="scope.row.schoolLevel == 2">高职</span>
                <span v-if="scope.row.schoolLevel == 3">本科</span>
            </template>
        </el-table-column>

        <el-table-column prop="responNameOrJob" label="负责人姓名" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" label="负责人手机" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="goLook(scope.row.id)">编辑</el-button>
                <!-- <el-button type="danger" size="mini">删除</el-button> -->
            </template>
        </el-table-column>
    </el-table>

    <div class="u-page-con">
        <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="page" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount" v-show="totalCount>0" style="text-align: center;"></el-pagination>
    </div>

</div>
</template>

<script>
export default {
    data() {
        return {
            schoolName: '',
            siteList: [],
            page: 1,
            pageSize: 10,
            totalCount: 0,
            getKeys(val) {
                return val.id;
            }
        };
    },
    components: {},
    computed: {
        userInfo() {
            return this.$store.state.auth;
        }
    },
    created() {
        this.getPilotList();
    },
    props: {
        certificateId: {
            type: String,
            default: ""
        }
    },
    methods: {
        goLook(id) {
            debugger;
            this.$router.push({
                name: 'teaTestDeclare',
                params: {
                    id: id,
                }
            })
        },
        handleSelectionChange() {},
        handleSizeChange(val) {
            this.pageSize = val;
            this.getPilotList();

        },
        onPageChangeHandler(val) {
            this.page = val
            this.getPilotList();

        },

        getPilotList() {
            var that = this;
            this.$http.post("/api/XOrg/QuestionnaireManager/getNaireList", {
                    schoolName: that.schoolName,
                    certificateId: that.certificateId,
                    PageSize: that.pageSize,
                    page: that.page
                })
                .then(rst => {
                    that.siteList = rst.list;
                    that.page = rst.pagination.pageIndex;
                    that.pageSize = rst.pagination.pageSize;
                    that.totalCount = rst.pagination.totalCount;
                })
        },

    }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    padding: 20px 30px 0 30px;

    // padding: 20px;
    // background: #fff;
    .el-input--suffix .el-input__inner {
        padding-right: 30px;
        height: 34px;
    }
}
</style>
